<template>
  <div>
    <main>
      <section>
        <div class="container">
          <div class="row">
            <mobileUserNav></mobileUserNav>

            <userInfo></userInfo>

            <div class="col_xl_8 col_l_8 col_m_8 col_s_12">
              <p class="user_title">
                <span v-if="hasEmailPasswordLogin">Change Password</span>
                <span v-else>Setup password</span>
              </p>


              <inputWrap
                  v-if="hasEmailPasswordLogin"
                  :title="'Old password'"
                  :type="'password'"
                  :placeholder="'e.g., sfk123$'"
                  @update:modelValue="old_pass = $event"
                  :inputData.sync="old_pass"
              ></inputWrap>

              <inputWrap
                  :title="'New password'"
                  :type="'password'"
                  :placeholder="'e.g., sfk123$'"
                  @update:modelValue="new_pass = $event"
                  :inputData.sync="new_pass"
              ></inputWrap>

              <inputWrap
                  :title="'Confirm password'"
                  :type="'password'"
                  :placeholder="'e.g., sfk123$'"
                  :inputData.sync="confirm_pass"
                  :errorText="'Password does not matche'"
                  @update:modelValue="confirm_pass = $event"
                  :hasError="hasError"
              ></inputWrap>

              <button
                  class="color_btn hover_op create_room"
                  :class="{ disabled: canUpdate }"
                  @click="SetNewPassword"
              >
                Change password
              </button>

            </div>
          </div>
        </div>
      </section>
    </main>

    <footerComponent></footerComponent>
  </div>
</template>

<script>
import footerComponent from "@/components/footerComponent.vue";
import inputWrap from "@/components/inputWrap.vue";
import userInfo from "@/components/userInfo.vue";
import mobileUserNav from "@/components/mobileUserNav.vue";
import {
  getAuth,
  reauthenticateWithCredential,
  linkWithCredential,
  updatePassword,
  reauthenticateWithPopup,
  EmailAuthProvider,
  GoogleAuthProvider,
  FacebookAuthProvider
} from "firebase/auth";

export default {
  name: "User_change_password",

  data() {
    return {
      hasError: false,
      old_pass: "",
      new_pass: "",
      confirm_pass: "",
    };
  },

  watch: {
    confirm_pass: function () {
      if (this.confirm_pass != this.new_pass) {
        this.hasError = true;
      } else {
        this.hasError = false;
      }
    },
  },

  computed: {
    hasEmailPasswordLogin() {
      return this.$store.state.user?.providerData.find(it => it.providerId === "password") != null
    },
    canUpdate() {
      if (
          this.confirm_pass != this.new_pass ||
          this.confirm_pass == "" ||
          this.new_pass == ""
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  components: {
    inputWrap,
    userInfo,
    footerComponent,
    mobileUserNav,
  },

  methods: {
    async SetNewPassword() {
      try {
        let user = getAuth().currentUser
        let credential

        if (this.hasEmailPasswordLogin) {
          credential = EmailAuthProvider.credential(user.email, this.old_pass)
          await reauthenticateWithCredential(user, credential)
              .then(() => updatePassword(user, this.new_pass))
        } else {
          let firstProvider = getAuth().currentUser.providerData.find(it => it.providerId !== "password")?.providerId

          if (firstProvider === GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD) {
            await reauthenticateWithPopup(user, new GoogleAuthProvider())
          } else if (firstProvider === FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD) {
            await reauthenticateWithPopup(user, new FacebookAuthProvider())
          }

          credential = EmailAuthProvider.credential(user.email, this.new_pass)
          await linkWithCredential(user, credential)
        }
        this.$store.commit("showModal", "password_changed");
      } catch (e) {
        console.error(e);
        this.$store.dispatch("onError", e)
      }
    },
  },
};
</script>

<style>
.create_room.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
